import React, { ReactNode, useEffect } from 'react';
import { useLocalizationContext } from '@im/react-localization';
import {
  useIsAuthenticated,
  useResellerProfile,
  useDecodedToken,
} from '../auth';

type Props = {
  children: ReactNode;
};

export function InitLocalization(props: Props) {
  const { children } = props;
  const isAuthenticated = useIsAuthenticated();
  const decodedToken = useDecodedToken();
  const resellerProspect = decodedToken?.resellerProspect || false;
  const { data: resellerProfile, refetch: fetchResellerProfile } =
    useResellerProfile();

  useEffect(() => {
    if (isAuthenticated && !resellerProspect) {
      fetchResellerProfile();
    }
  }, [fetchResellerProfile, isAuthenticated, resellerProspect]);

  const localization = useLocalizationContext();
  const locale = localization.locale;

  useEffect(() => {
    if (locale) document.querySelector('html')?.setAttribute('lang', locale);
  }, [locale]);

  useEffect(() => {
    if (resellerProfile) {
      const newCurrency = resellerProfile['currencyCode'];
      if (newCurrency) {
        localization.setCurrencyCode(newCurrency);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resellerProfile]);

  return <>{children}</>;
}
